export enum Rating {
    None = "0",
    One = "1",
    Two = "2",
    Three = "3",
    Four = "4",
    Five = "5",
}

export function isRating(value: unknown): value is Rating {
    const ratingValues = Object.values(Rating);
    return !!ratingValues.find((v) => v === value);
}

export function getNumber(value: Rating): number {
    try {
        return parseInt(value, 10);
    } catch {
        return 0;
    }
}
